import { ICustomEntryPoint } from "../GameEntryPoint";
import { IGameState } from "../../IGameState";
import { addGateFriend } from "../../../Player/PlayerStateHelper";
import SDKIntegrationsHelper from "../../../../Utility/SDK/SDKIntegrationsHelper";

export function gateUnlockAddFriendRequest(payload: ICustomEntryPoint, state:IGameState) {
    // Instantly respond to gate unlock request.
    // TODO: UI dialog "You have helped a friend unlock a gate."
    SDKIntegrationsHelper.sendGateUnlockFriendResponse(
        payload.userId
    );
    // State does not change.
    return state;
}
